import React, { ReactElement } from 'react'

import PrivacyPolicy from '../components/terms/PrivacyPolicy'
import { CompanyReducer } from '../reducers/companies'
import { connectToReducer } from '../utils/reducer-utils'

type Reducers = {
  companies: CompanyReducer
}

function PrivacyPolicyContainer(props: Reducers): ReactElement | null {
  return <PrivacyPolicy company={props.companies.company} />
}

export default connectToReducer<Reducers, any>(
  (state) => ({
    companies: state.companies,
  }),
  {}
)(PrivacyPolicyContainer)
